export default __webpack_public_path__ + "static/media/TG.5b8111c5.gif";